import { esDO } from './es-DO';

const overrides: Partial<typeof esDO> = {
  // Colombia mayormente igual a es-DO
  'billing.upgrade': 'Mejorar plan',
};

export const esCO = { ...esDO, ...overrides };
